var _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEdit = _ref => {
  let svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 12.9374V15.7499H6.0625L14.3575 7.45488L11.545 4.64238L3.25 12.9374ZM16.5325 5.27988C16.602 5.21049 16.6572 5.12808 16.6948 5.03735C16.7325 4.94662 16.7518 4.84936 16.7518 4.75113C16.7518 4.6529 16.7325 4.55564 16.6948 4.46491C16.6572 4.37418 16.602 4.29177 16.5325 4.22238L14.7775 2.46738C14.7081 2.39785 14.6257 2.34269 14.535 2.30506C14.4442 2.26742 14.347 2.24805 14.2488 2.24805C14.1505 2.24805 14.0533 2.26742 13.9625 2.30506C13.8718 2.34269 13.7894 2.39785 13.72 2.46738L12.3475 3.83988L15.16 6.65238L16.5325 5.27988Z",
    fill: "#F1712C"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.ee910db8.svg";
export { ForwardRef as ReactComponent };